//i18n-setup.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang/deskbooker-bundle'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages: messages, // set locale messages
  silentTranslationWarn: true
})

const loadedLanguages = ['en'] // our default language that is preloaded

function setI18nLanguage (lang) {
  console.log("setting lang:", lang)
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

const refreshCustomLocales = function(customLocales) {
  let lang = navigator.language || navigator.userLanguage; 
  i18n.setLocaleMessage(lang, customLocales)
  return setI18nLanguage(lang)
}

const loadLanguageAsync = function(lang, customLocales) {
  console.log("loadLanguageAsync() for lang:", lang)

  /*
    OK, 
    SO WE WERE MAKING GOOD PROGRESS HERE BUT HAD TO STOP TO GIVE CATIA PETS.
    NOT SURE WHAT LINE 8-10 OF THIS FILE IS ACHIEVING, BUT WE MAY NEED TO UPDATE 
  */
  
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language hasn't been loaded yet
  // check if it's a custom lang
  if(customLocales){
    // do some custom logic...
    i18n.setLocaleMessage(lang, customLocales)
    loadedLanguages.push(lang)
    return setI18nLanguage(lang)
  } else {
    return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.js`).then(
      messages => {
        i18n.setLocaleMessage(lang, messages.default)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      }
    ).catch(err=>{
      console.log("localisation error:", err)
    })
  }
}

export default {
  loadLanguageAsync,
  i18n,
  refreshCustomLocales
}